export enum SortedWorkoutsSelectOption {
  Default = '',
  LastAdded = 'Last Added',
  Running = 'Running',
  Cycling = 'Cycling',
  Favorite = 'Favorite',
  Distance = 'Distance',
  Duration = 'Duration',
}
